"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _WalletTicketsRow = _interopRequireDefault(require("./WalletTicketsRow"));

var _TicketDashedLine = _interopRequireDefault(require("./TicketDashedLine"));

var _TicketMain = _interopRequireDefault(require("./TicketMain"));

var _TicketMainBottomRow = _interopRequireDefault(require("./TicketMainBottomRow"));

var _TicketMainMiddleRow = _interopRequireDefault(require("./TicketMainMiddleRow"));

var _TicketMainTopRow = _interopRequireDefault(require("./TicketMainTopRow"));

var _TicketStub = _interopRequireDefault(require("./TicketStub"));

var _TicketText = _interopRequireDefault(require("./TicketText"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));

var rows = new Array(4);

var Wrapper = function Wrapper() {
  return /*#__PURE__*/_react.default.createElement(_WalletTicketsRow.default, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Card, {
    minHeight: "232px",
    margin: "0 0 1rem",
    padding: "0"
  }, /*#__PURE__*/_react.default.createElement(_TicketMain.default, {
    isSkeleton: true
  }, /*#__PURE__*/_react.default.createElement(_TicketMainTopRow.default, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Skeleton, {
    display: "block",
    skeletonHeight: "18px",
    skeletonWidth: "240px",
    margin: "10px 0 32px"
  }), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Skeleton, {
    display: "block",
    skeletonHeight: "16px",
    skeletonWidth: "180px",
    margin: "10px 0 32px"
  }), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Skeleton, {
    display: "block",
    skeletonHeight: "16px",
    skeletonWidth: "100px"
  }))))));
};

var _default = Wrapper;
exports.default = _default;